import { PublicConfig } from "@/shared/PublicConfig";

export const SAMPLE_POLICY_URL = PublicConfig.PTZ_US.SPOT_MARKETING_URL + PublicConfig.PTZ_US.SAMPLE_POLICY_PATH;
export const MEMBER_CENTER_URL = PublicConfig.PTZ_US.SPOT_MARKETING_URL + PublicConfig.PTZ_US.MEMBER_CENTER_PATH;
export const SPOT_PERKS_URL = PublicConfig.PTZ_US.SPOT_MARKETING_URL + PublicConfig.PTZ_US.SPOT_PERKS_PATH;
export const START_CLAIM_URL = PublicConfig.PTZ_US.MEMBER_CLAIMS_URL;
